"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImplementationDocumentSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ProductImplementationDocumentSearchResponse extends common_1.PaginatedResponse {
}
exports.ProductImplementationDocumentSearchResponse = ProductImplementationDocumentSearchResponse;
//# sourceMappingURL=product-implementation-document-search.response.js.map